
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 31 30","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.47 28.82c-2.79 0-5.517-.813-7.837-2.335a13.908 13.908 0 01-5.196-6.216 13.617 13.617 0 01-.802-8.003 13.775 13.775 0 013.862-7.092 14.19 14.19 0 017.224-3.79 14.35 14.35 0 018.151.79 14.054 14.054 0 016.33 5.103 13.672 13.672 0 012.376 7.696 13.74 13.74 0 01-4.138 9.787 14.256 14.256 0 01-9.97 4.06zm0-25.395c-2.325 0-4.598.676-6.532 1.944a11.593 11.593 0 00-4.332 5.18 11.35 11.35 0 00-.672 6.669A11.48 11.48 0 007.15 23.13a11.827 11.827 0 006.02 3.16 11.96 11.96 0 006.793-.654 11.714 11.714 0 005.278-4.25 11.395 11.395 0 001.984-6.413 11.45 11.45 0 00-3.445-8.16 11.88 11.88 0 00-8.31-3.388z"}}),_c('path',{attrs:{"d":"M11.359 13.818c.973 0 1.763-.775 1.763-1.73 0-.957-.79-1.732-1.763-1.732-.974 0-1.763.775-1.763 1.731 0 .956.79 1.731 1.763 1.731zM19.587 13.818c.973 0 1.763-.775 1.763-1.73 0-.957-.79-1.732-1.763-1.732-.974 0-1.763.775-1.763 1.731 0 .956.79 1.731 1.763 1.731zM15.475 23.238a8.373 8.373 0 01-4.107-1.087 8.182 8.182 0 01-3.01-2.95 1.138 1.138 0 01.43-1.574 1.188 1.188 0 011.602.422 5.81 5.81 0 002.146 2.112 5.946 5.946 0 002.935.773c1.03 0 2.043-.267 2.935-.773a5.81 5.81 0 002.147-2.112c.155-.265.412-.459.712-.538.301-.08.622-.038.892.114.27.153.467.405.548.7.081.296.04.61-.116.876a8.182 8.182 0 01-3.009 2.95 8.373 8.373 0 01-4.105 1.087z"}})])
          )
        }
      }
    